import React from 'react';

export const FaceToFaceMeetingIcon = ({ className }) => <i className={`fa fa-link ${className}`} />;
export const TelephoneMeetingIcon = ({ className }) => <i className={`fa fa-phone ${className}`} />;
export const ScheduledContactIcon = ({ className }) => <i className={`fa fa-phone ${className}`} />;
export const VisitReportActionIcon = ({ className }) => <i className={`fa fa-clock-o ${className}`} />;
export const AdminDayIcon = ({ className }) => <i className={`fa fa-pencil ${className}`} />;
export const HolidayIcon = ({ className }) => <i className={`fa fa-plane ${className}`} />;
export const EventIcon = ({ className }) => <i className={`fa fa-ticket ${className}`} />;
